/**
 * Single source of truth for the Android payment-return routes. Each appPath
 * must stay in lockstep with the android:pathPrefix intent-filter in the
 * Android app's manifest, and with the matching entry in
 * .stitchfix/fixops/values.prod*.yaml — see constants.test.ts, which checks
 * these against the ingress config.
 */
export const FIX_CHECKOUT_ORDER_RESUME_ROUTE = {
  appPath: '/android/fixcheckout/order/resume',
  webPath: '/fixcheckout/order/resume'
} as const;
export const MY_ITEMS_ORDERS_RESUME_ROUTE = {
  appPath: '/android/my-items/orders/resume',
  webPath: '/my-items/orders/resume'
} as const;